import { Route } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Tags from "./Pages/Tags";
import { loadContactTag, loadContactTags } from "./apis/contactTagAPI";
import TagChanges from "./Pages/TagChanges";
import Titles from "./Pages/Titles";
import { loadContactTitles } from "./apis/contactTitleAPI";
import Industries from "./Pages/Industries";
import { loadIndustries } from "./apis/industriesAPI";
import { loadLocations } from "./apis/locationsAPI";
import Contacts from "./Pages/Contacts";
import { loadContact, loadContacts } from "./apis/contactsAPI";
import Locations from "./Pages/Locations";
import ContactChanges from "./Pages/ContactChanges";





const contactRouter = () => (
  <Route path="/contact" element={<Layout />}>
    <Route index element={<Contacts />} loader={loadContacts} />
    <Route path="tags" element={<Tags />} loader={loadContactTags} />
    <Route path="titles" element={<Titles />}  loader={loadContactTitles} />
    <Route path="industries" element={<Industries />} loader={loadIndustries} />
    <Route path="locations" element={<Locations />} loader={loadLocations} />
    <Route path="contacts" element={<Contacts />} loader={loadContacts} />
    <Route path="contacts/:action" element={<ContactChanges />} loader={params => loadContact(params.params.action)} />
    <Route path="tags/:action" element={<TagChanges />} loader={params => loadContactTag(params.params.action)} />
  </Route>
);


export default contactRouter;